// dashboard
import Ecommerce from "pages/Dashboards/Ecommerce";

import UserProfile from "pages/Authentication/UserProfile";
import Login from "pages/Authentication/Login";
import Logout from "pages/Authentication/LogOut";
import Register from "pages/Authentication/Register";
import Customer from "pages/Customer";
import Wallet from "pages/Wallet";
import Transfer from "pages/Transfer";
import Transaction from "pages/Transaction";
import MovementCategory from "pages/MovementCategory";
import Movement from "pages/Movement";
import CreditSimulator from "pages/CreditSimulator";
import Loan from "pages/Loan";
import LoanView from "pages/Loan/LoanView";
import LoanApplication from "pages/LoanApplication";
import LoanPayment from "pages/LoanPayment";
import CreditDestination from "pages/CreditDestination";
import TypeLoan from "pages/TypeLoan";
import WarrantyTypes from "pages/WarrantyTypes";
import LoanPaymentsReport from "pages/Reports/LoanPayment";
import LoanReport from "pages/Reports/Loan";
import ExpenseAndIncomeReport from "pages/Reports/ExpenseAndIncome";
import EconomicActivityTypes from "pages/EconomicActivityTypes";

interface RouteObject {
  path: string;
  component: React.ComponentType<any>; // Use React.ComponentType to specify the type of the component
  exact?: boolean;
}

const authProtectedRoutes: Array<RouteObject> = [
  // Dashboard
  { path: "/", component: Ecommerce },
  { path: "/dashboard", component: Ecommerce },

  // profile
  { path: "/user-profile", component: UserProfile },

  //customers
  { path: "/customers", component: Customer },

  //wallets
  { path: "/wallets", component: Wallet },

  // Transfers
  { path: "/transfers", component: Transfer },

  // Transfers
  { path: "/transactions", component: Transaction },

  // Expenses Categories
  {path: "/movementCategories", component: MovementCategory},

  // Expenses
  {path: "/movements", component: Movement},

  // Loans
  {path: "/loans", component: Loan},
  { path: "/loan-info/:loanId", component: LoanView },

  // Loan Application
  {path: "/loanApplications", component: LoanApplication},

  //Loan Payments
  {path: "/loanPayments", component: LoanPayment},

  //Credit Destination
  {path : "/creditDestinations", component: CreditDestination},

  // Type Loan
  {path : "/typeLoans", component: TypeLoan},

  // Warranty Types
  {path : "/warrantyTypes", component: WarrantyTypes},

  {path : "/creditSimulator", component: CreditSimulator},

  // Economic Activity Types
  {path : "/EconomicActivityTypes", component: EconomicActivityTypes},

  // Loan Payments Report
  {path: "/reports/loanPayments", component: LoanPaymentsReport},

  // Loan Report
  {path: "/reports/activeLoans", component: LoanReport},

  // Expense and Income Report
  {path: "/reports/expensesAndIncome", component: ExpenseAndIncomeReport},
];

const publicRoutes = [

  // authentication
  { path: "/login", component: Login },
  { path: "/logout", component: Logout },
  { path: "/register", component: Register },

]

export { authProtectedRoutes, publicRoutes };
